import React, { FC } from 'react';

// Utils
import { classNames, defaultHandleTeamClick } from '@sportal365/smp-widget-utils';

// Components
import Image from '../../../../../../../packages/HOC/AccessibilityImage';

// Types
import { ISubscriberInfo } from '../../../../../../../packages/types';
import { INormalizeTeam } from '../../../../types';

import { TEAM_ENTITY } from '../../../../../../../packages/constants/entityTypes';

interface Props extends INormalizeTeam {
  withReversedDisplay?: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const TeamInfo: FC<Props> = ({ team, withReversedDisplay, handleClick }) => {
  const handleTeamClick = () => defaultHandleTeamClick(handleClick, { id: team?.id ?? '', name: team?.name ?? '' });

  return (
    <a href={team.url} target={team.target} className='no-underline h-full' onClick={handleTeamClick}>
      <div
        className={classNames(
          {
            'flex items-center gap-1 tb:gap-2': true,
            'flex-col tb:flex-row-reverse': withReversedDisplay,
            'flex-col tb:flex-row': !withReversedDisplay,
          },
          `team-${team.id}-info-container`,
        )}
      >
        <Image
          src={team.image}
          alt={team.name}
          entityType={TEAM_ENTITY}
          className={classNames({ 'h-[42px] tb:h-[64px] w-[42px] tb:w-[64px]': true }, `team-${team.id}-image`)}
        />
        <span className={classNames({ 'font-bold text-hiContrast text-center text-5 tb:text-7': true }, `team-${team.id}-name`)}>
          {team.name}
        </span>
      </div>
    </a>
  );
};
